/* @ngInject */
const myCopyWagonInput = (
  wagonUtils,
  wagonRequest,
) => {
  return {
    restrict: 'E',
    scope: {
      myId: '=',
      myRequired: '=?',
    },
    template: require('./myCopyWagonsInput.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.text = ''
      $scope.resultat = ''
      $scope.tableResult = []

      $scope.boldMatchWagonId = (search, wagonId) => {
        const notMatchedParts = wagonId.split(search)
        const formattedId = wagonUtils.idToString(wagonId)
        const dummySearch = 'x'.repeat((notMatchedParts[0] && notMatchedParts[0].length) || 0) + search + 'x'.repeat((notMatchedParts[1] && notMatchedParts[1].length) || 0)
        const formattedSearch = wagonUtils.idToString(dummySearch)

        let index = 0
        let formattedAndHighlight = ''
        let match = false
        for (const searchChar of formattedSearch) {
          const idChar = formattedId[index]
          if (searchChar === ' ' || searchChar === '-') {
            formattedAndHighlight += idChar
          } else {
            if (!match && idChar === searchChar) {
              match = true
              formattedAndHighlight += `<strong>`
            }
            if (match && idChar !== searchChar) {
              match = false
              formattedAndHighlight += `</strong>`
            }

            formattedAndHighlight += idChar
          }
          index++
        }

        return `<span>${formattedAndHighlight}</span>`
      }

      $scope.reinitForm = () => {
        if (confirm(`Êtes-vous sûr de vouloir ré-initialiser la recherche ?`)) {
          $scope.searched = false
          $scope.showWagons = false
          $scope.text = ''
        }
      }

      $scope.searched = false

      $scope.handleInput = async () => {
        const textres = ''
        $scope.searched = true
        $scope.showWagons = false

        const wagonIds = $scope.text
          .split(/\n|\t|,|;/)
          .map(line => line
            .replace(/\s/g, '')
            .replace(/-/g, '')
          )
          .filter(line =>
            line &&
            line.length >= 4 &&
            !!line
              .match(/^[0-9]*$/g)
          )

        console.log(wagonIds)

        $scope.tableResult = []

        const batchResults = await wagonRequest.getIncompleteIds(wagonIds)

        let wagonIndex = 0

        for (const wagonId of wagonIds) {
          wagonIndex++
          const wagons = batchResults[wagonId] || []

          const rowResult = {
            wagonId: wagonId || '',
            wagons: wagons,
            info: '',
            color: '',
            radios: [],
            model: '',
          }

          let index = 0
          for (const searchWagon of wagons) {
            rowResult.radios.push({
              label: $scope.boldMatchWagonId(wagonId, searchWagon.id),
              id: `${wagonIndex}${searchWagon.id}`,
              value: searchWagon.id,
            })

            if (index === 0) {
              rowResult.model = searchWagon.id
            }

            index++
          }

          if (wagonId.length >= 12 && !wagonUtils.isIdValid(wagonId)) {
            rowResult.info = `Numéro erroné`
            rowResult.color = `red`
          } else if (wagons.length === 0) {
            rowResult.info = `inconnu dans SyGeM`
            rowResult.color = `grey`
          } else if (wagons.length === 1) {
            rowResult.info = `1 wagon`
            rowResult.color = `green`
          } else {
            rowResult.info = `${wagons.length} wagons`
            rowResult.color = `blue`
          }

          $scope.tableResult.push(rowResult)
        }

        $scope.resultat = textres
      }

      $scope.wagons = []
      $scope.showWagons = false

      $scope.displayWagons = () => {
        $scope.wagons = $scope.tableResult
          .map(tr => tr.wagons.find(w => w.id === tr.model))
          .filter(w => w)
        $scope.showWagons = true
      }
    },
    link: {
      pre: (scope, element, attrs) => { },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myCopyWagonInput



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/inputs/myCopyWagonsInput.js